export default __webpack_public_path__ + "static/media/LotusGoFreshModel.65e046ac.svg";